import { HCP_CUBE_NAME } from '@/api/hcp';
import { FilterConfigFixed } from '@/types/filter';

const hcpWithLinkedInFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.withLinkedInLabel',
  type: 'checkbox',
  defaultValue: false,
  clearable: false,
  searchable: false,
  format: ({ value, t }) => {
    if (value) return t('global.filters.formControls.withLinkedInLabel');
    return null;
  },
  applyFilter: value => {
    const isChecked = Boolean(value);
    if (!isChecked) return undefined;
    return {
      member: `${HCP_CUBE_NAME}.linkedin_flag`,
      operator: 'equals',
      values: ['true'],
    };
  },
};

export default hcpWithLinkedInFilter;
